module.exports = __webpack_public_path__ + "assets/img/lines.b2ab86e0.svg";